import { motion } from "framer-motion";
import { Network, Sparkles, Cloud, Eye, BarChart3, MessageSquare } from "lucide-react";
import { PLATFORM_FEATURES } from "@/lib/data";

const iconMap = {
    network: Network,
    sparkles: Sparkles,
    cloud: Cloud,
    eye: Eye,
    "bar-chart": BarChart3,
    "message-square": MessageSquare,
};

const PlatformFeatures = () => (
    <section data-testid="platform-features-section" className="sxe-section relative bg-[#08031a]">
        <div className="sxe-container">
            <div className="max-w-3xl">
                <div className="overline"><span className="dot" /> Platform Features</div>
                <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05] text-white mt-5">
                    Everything an enterprise LxP{" "}
                    <span className="text-gradient">should have been years ago</span>.
                </h2>
            </div>

            <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {PLATFORM_FEATURES.map((f, i) => {
                    const Icon = iconMap[f.icon] || Sparkles;
                    return (
                        <motion.div
                            key={f.title}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.55, delay: i * 0.05 }}
                            className="sxe-card p-7 flex flex-col justify-between min-h-[220px]"
                            data-testid={`platform-feature-${i}`}
                        >
                            <div>
                                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#A100FF]/25 to-[#7B00CC]/[0.05] border border-[#C266FF]/25 flex items-center justify-center">
                                    <Icon className="w-5 h-5 text-[#E9CCFF]" />
                                </div>
                                <h3 className="font-display text-white text-xl md:text-2xl font-medium tracking-tight mt-5">{f.title}</h3>
                            </div>
                            <p className="text-[#B0A3C4] text-[14px] leading-relaxed">{f.desc}</p>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    </section>
);

export default PlatformFeatures;
